import {
  disableDebugLogging,
  enableDebugLogging,
} from "./session-logger";
import {
  exposePerformanceUtilities,
  startPerformanceMonitoring,
} from "./session-performance";

export { clearAllCookies, getCookie, setCrossDomainCookie } from "./cookie-utils";
export { buildServiceUrl, navigateToClientPage } from "./navigation-utils";
export { logoutAndRedirect, performLogout, performQuickLogout } from "./logout-utils";

/** Initialize diagnostics that do not persist or restore authentication state. */
export const initializeSessionManager = (options = {}) => {
  const {
    enableDebug = process.env.NODE_ENV === "development",
    enablePerformanceMonitoring = true,
    exposeDebugTools = process.env.NODE_ENV === "development",
  } = options;

  if (enableDebug) {
    enableDebugLogging();
  }
  if (enablePerformanceMonitoring) {
    startPerformanceMonitoring();
  }
  if (exposeDebugTools) {
    exposePerformanceUtilities();
  }

  return () => {
    if (enableDebug) {
      disableDebugLogging();
    }
  };
};
